var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRecipient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "#CB998D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5671 19.6718C28.4551 18.2158 27.9591 17.5918 26.8871 17.3358C28.1351 16.9518 28.8391 16.0078 28.8391 14.6958C28.8391 12.8878 27.5751 11.7998 25.5591 11.7998H20.0391V22.9998H21.9751V18.0878H25.0311C26.0551 18.0878 26.4871 18.4078 26.6311 19.6558C26.6631 19.9278 26.7271 22.3918 27.0151 22.9998H29.1271C28.7911 22.6798 28.6631 20.9518 28.5671 19.6718ZM25.1271 13.4478C26.3271 13.4478 26.8871 14.0558 26.8871 14.9518C26.8871 16.1038 26.3271 16.5678 24.9671 16.5678H21.9751V13.4478H25.1271Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8504 18.1477H14.2904V23.0077H11.6024V18.1477H7.06641V15.7357H11.6024V10.8877H14.2904V15.7357H18.8504V18.1477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRecipient);
export default __webpack_public_path__ + "static/media/add-recipient.a2a45fffb42cf126796addaf15d65a0a.svg";
export { ForwardRef as ReactComponent };